
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.5 8.44C34.28 8.44 34.12 3 29.73 3S25.18 8.44 20 8.44h0C14.82 8.44 14.66 3 10.27 3S5.72 8.44.5 8.44M39.5 22.73c-5.22 0-5.38-5.46-9.77-5.46s-4.55 5.46-9.73 5.46h0c-5.22 0-5.38-5.46-9.77-5.46S5.72 22.73.5 22.73M39.5 37c-5.22 0-5.38-5.46-9.77-5.46S25.18 37 20 37h0c-5.22 0-5.38-5.46-9.77-5.46S5.72 37 .5 37","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    